const currentLanguage = () => (localStorage.getItem('blablacolis_language') === 'en' ? 'en' : 'fr');

export const formatPrice = (v) => new Intl.NumberFormat(currentLanguage(), { style: 'currency', currency: 'EUR' }).format(Number(v || 0));
export const formatDate = (s) => {
  if (!s) return '—';
  try {
    const d = new Date(s);
    return d.toLocaleDateString(currentLanguage() === 'en' ? 'en-GB' : 'fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch { return s; }
};
export const formatDateTime = (s) => {
  if (!s) return '—';
  try {
    const d = new Date(s);
    return d.toLocaleString(currentLanguage() === 'en' ? 'en-GB' : 'fr-FR', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' });
  } catch { return s; }
};

export const STATUS_LABELS = {
  open: 'Ouverte', expired: 'À renouveler', matched: 'Mis en relation', in_progress: 'En cours',
  delivered: 'Livré', cancelled: 'Annulé', dispute: 'Litige',
  pending: 'En attente', accepted: 'Accepté', refused: 'Refusé',
  picked_up: 'Pris en charge', in_transit: 'En transit', arrived_relay: 'Au relais',
  active: 'Actif', full: 'Complet', completed: 'Terminé',
  investigating: 'En cours de traitement', resolved: 'Résolue', closed: 'Fermée',
  approved: 'Approuvé', rejected: 'Rejeté',
};

export const STATUS_LABELS_EN = {
  open: 'Open', expired: 'Renewal needed', matched: 'Matched', in_progress: 'In progress', delivered: 'Delivered', cancelled: 'Cancelled',
  dispute: 'Dispute', pending: 'Pending', accepted: 'Accepted', refused: 'Declined', picked_up: 'Picked up',
  in_transit: 'In transit', arrived_relay: 'At relay point', active: 'Active', full: 'Full', completed: 'Completed',
  investigating: 'Under review', resolved: 'Resolved', closed: 'Closed', approved: 'Approved', rejected: 'Rejected',
};

export const STATUS_COLORS = {
  open: 'bg-blue-100 text-blue-800',
  expired: 'bg-amber-100 text-amber-800',
  pending: 'bg-amber-100 text-amber-800',
  accepted: 'bg-green-100 text-green-800',
  refused: 'bg-red-100 text-red-800',
  matched: 'bg-violet-100 text-violet-800',
  in_progress: 'bg-orange-100 text-orange-800',
  picked_up: 'bg-orange-100 text-orange-800',
  in_transit: 'bg-purple-100 text-purple-800',
  arrived_relay: 'bg-indigo-100 text-indigo-800',
  delivered: 'bg-emerald-100 text-emerald-800',
  cancelled: 'bg-gray-200 text-gray-700',
  dispute: 'bg-red-100 text-red-800',
  active: 'bg-emerald-100 text-emerald-800',
  full: 'bg-amber-100 text-amber-800',
  completed: 'bg-blue-100 text-blue-800',
  investigating: 'bg-orange-100 text-orange-800',
  resolved: 'bg-emerald-100 text-emerald-800',
  closed: 'bg-gray-200 text-gray-700',
  approved: 'bg-emerald-100 text-emerald-800',
  rejected: 'bg-red-100 text-red-800',
};

const localized = (fr, en) => currentLanguage() === 'en' ? en : fr;

export const TRANSPORT_LABELS = {
  get car() { return localized('Voiture', 'Car'); }, get bus() { return 'Bus'; }, get train() { return 'Train'; }, get plane() { return localized('Avion', 'Plane'); },
  get boat() { return localized('Bateau', 'Boat'); }, get motorcycle() { return localized('Moto', 'Motorcycle'); }, get truck() { return localized('Camion', 'Truck'); }, get van() { return localized('Utilitaire', 'Van'); }, get bicycle() { return localized('Vélo', 'Bicycle'); },
};

const parcelType = (value, fr, en) => ({ value, get label() { return localized(fr, en); } });

export const PARCEL_TYPES = [
  parcelType('documents', 'Documents', 'Documents'),
  parcelType('small', 'Petit colis', 'Small parcel'),
  parcelType('medium', 'Colis moyen', 'Medium parcel'),
  parcelType('large', 'Gros colis', 'Large parcel'),
  parcelType('fragile', 'Fragile', 'Fragile'),
  parcelType('food', 'Alimentaire', 'Food'),
  parcelType('other', 'Autre', 'Other'),
];
